module.exports = __webpack_public_path__ + "static/media/25487467_1703515436390307_7960391174795403493_o.41b87858.jpg";